var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInternational(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2503 10.0001C17.2503 14.0043 14.0043 17.2503 10.0001 17.2503C5.99599 17.2503 2.75 14.0043 2.75 10.0001C2.75 5.99599 5.99599 2.75 10.0001 2.75C14.0043 2.75 17.2503 5.99599 17.2503 10.0001Z",
    stroke: "#121517",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99937 2.65051L9.99755 2.65464L9.99937 2.65051ZM9.99937 2.65051L10.0007 2.64751L9.99937 2.65051ZM12.5841 10.0002C12.5841 12.9045 11.5656 15.4713 10.0007 17.2013C8.4358 15.4713 7.4173 12.9045 7.4173 10.0002C7.4173 7.09595 8.4358 4.52918 10.0007 2.79919C11.5656 4.52918 12.5841 7.09595 12.5841 10.0002ZM9.74039 2.05462C9.65834 2.09065 9.58466 2.14331 9.52401 2.20927L9.74039 2.05462Z",
    stroke: "#121517",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.80005 10H17.2005",
    stroke: "#121517",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternational);
export default __webpack_public_path__ + "static/media/International.ce3e07e77800826db9b3f33a26e55f2a.svg";
export { ForwardRef as ReactComponent };